import React from 'react';

// Provider
import UserProvider from './UserProvider';
import ModeProvider from './ModeProvider';

function AppProvider({ children }) {
  return (
    <ModeProvider>
      <UserProvider>
        {children}
      </UserProvider>
    </ModeProvider>
  );
}

export default AppProvider;
